import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import api from '../utils/api';
import toast from 'react-hot-toast';
import VintageLayout from '../components/layout/VintageLayout';

const ResetPasswordPage: React.FC = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const token = searchParams.get('token');

    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            toast.error('Les mots de passe ne correspondent pas');
            return;
        }

        setIsLoading(true);
        try {
            await api.post('/auth/reset-password', { token, password });
            toast.success('Mot de passe mis à jour !');
            navigate('/login');
        } catch (error) {
            toast.error('Lien invalide ou expiré');
        } finally {
            setIsLoading(false);
        }
    };

    if (!token) {
        return (
            <VintageLayout>
                <div className="min-h-screen flex items-center justify-center p-4">
                    <div className="card-vintage max-w-md w-full text-center p-8">
                        <h2 className="text-2xl font-serif font-bold text-red-400 mb-4">Lien Invalide</h2>
                        <p className="text-navy-600 mb-6">Ce lien de réinitialisation est manquant ou incomplet.</p>
                        <button onClick={() => navigate('/login')} className="btn-vintage w-full">
                            Retour à la connexion
                        </button>
                    </div>
                </div>
            </VintageLayout>
        );
    }

    return (
        <VintageLayout>
            <div className="min-h-screen flex items-center justify-center p-4">
                <div className="card-vintage max-w-md w-full p-8 shadow-2xl border-2 border-gold-500/30">
                    <div className="text-center mb-8">
                        <h1 className="text-3xl font-serif font-bold text-navy-900 mb-2">Nouveau Mot de Passe</h1>
                        <p className="text-navy-600 text-sm">Entrez votre nouveau mot de passe pour sécuriser votre compte.</p>
                    </div>

                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div>
                            <label className="block text-sm font-medium text-navy-700 mb-1">Nouveau mot de passe</label>
                            <input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="w-full bg-cream-50 border border-navy-300 rounded-lg px-4 py-3 text-navy-900 focus:border-gold-500 outline-none transition-colors"
                                required
                                minLength={6}
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-navy-700 mb-1">Confirmer le mot de passe</label>
                            <input
                                type="password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                className="w-full bg-cream-50 border border-navy-300 rounded-lg px-4 py-3 text-navy-900 focus:border-gold-500 outline-none transition-colors"
                                required
                                minLength={6}
                            />
                        </div>

                        <button
                            type="submit"
                            disabled={isLoading}
                            className="btn-vintage w-full py-3 text-lg font-bold shadow-lg hover:shadow-gold-500/20"
                        >
                            {isLoading ? 'Mise à jour...' : 'Réinitialiser le mot de passe'}
                        </button>
                    </form>
                </div>
            </div>
        </VintageLayout>
    );
};

export default ResetPasswordPage;
